import { create } from "zustand"

type CompareVersionDialogState = {
  isOpen: boolean
}

type CompareVersionDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useCompareVersionDialog = create<CompareVersionDialogState & CompareVersionDialogActions>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  })
)

export default useCompareVersionDialog
